import { LineProps } from "../../../atoms/line"
import { AddressInfoItemProps } from "../../../molecules/address"

export type ShortFormElementContent = LineProps | AddressInfoItemProps | undefined
